import React from 'react';

const LoadingSkeleton = () => {
  return (
    <div className="space-y-4">
      {Array.from({ length: 5 })?.map((_, index) => (
        <div 
          key={index}
          className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6"
        >
          <div className="flex items-start space-x-4">
            {/* Poster skeleton */}
            <div className="flex-shrink-0 w-16 h-24 bg-white bg-opacity-20 rounded-lg shimmer"></div>

            {/* Content skeleton */}
            <div className="flex-grow">
              {/* Title and musical */}
              <div className="mb-3">
                <div className="h-6 bg-white bg-opacity-20 rounded shimmer w-2/3 mb-2"></div>
                <div className="h-4 bg-white bg-opacity-20 rounded shimmer w-1/2"></div>
              </div>

              {/* Stats grid */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3">
                {Array.from({ length: 3 })?.map((_, statIndex) => (
                  <div key={statIndex} className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-white bg-opacity-20 rounded-full shimmer"></div>
                    <div className="flex-grow">
                      <div className="h-4 bg-white bg-opacity-20 rounded shimmer w-20 mb-1"></div>
                      <div className="h-3 bg-white bg-opacity-20 rounded shimmer w-16"></div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Description skeleton */}
              <div className="mb-2">
                <div className="h-3 bg-white bg-opacity-20 rounded shimmer w-full mb-1"></div>
                <div className="h-3 bg-white bg-opacity-20 rounded shimmer w-3/4"></div>
              </div>

              {/* Footer info */}
              <div className="flex justify-between">
                <div className="h-3 bg-white bg-opacity-20 rounded shimmer w-24"></div>
                <div className="h-3 bg-white bg-opacity-20 rounded shimmer w-16"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;